/** @file cameraPitchDelta: how far the real camera pitch is from the profile's (decision 11, design 4.3). */
import type { Profile } from '@zilo/pose3d-format/types/profile';

/** `profile.camera.pitch - cameraPitchDeg`; `outsideRange` when the camera leaves `camera.pitchRange` (CAMERA_MISMATCH). */
export function cameraPitchDelta(profile: Profile, cameraPitchDeg: number): { deltaDeg: number; outsideRange: boolean } {
  const [lo, hi] = profile.camera.pitchRange;
  return { deltaDeg: profile.camera.pitch - cameraPitchDeg, outsideRange: cameraPitchDeg < lo || cameraPitchDeg > hi };
}
